import React, { Component } from 'react'

class Loader extends Component {
  render() {
    return (
      <div
        className={
          'loader ' + (this.props.color !== '' ? this.props.color : '')
        }
      ></div>
    )
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js